import { css } from 'styled-components';
import { type PropsWithTheme } from '../../styled';

export type ColumnTable = {
  $index: number;
  $isFirstColumn: boolean;
  $isLastColumn: boolean;
  $rowsCount: number;
};

type MixinProps = ColumnTable & PropsWithTheme;

const overlayMixin = ({ $index, $rowsCount }: MixinProps) => css`
  content: '';
  pointer-events: none;
  display: block;
  position: relative;
  top: 0;
  left: 0;
  grid-area: 1 / ${$index + 1} / ${$rowsCount + 1} / ${$index + 2};
`;

export const borderMixin = ({
  $isLastColumn,
  theme: {
    column: { borderColor }
  }
}: MixinProps) => css<ColumnTable>`
  &::after {
    ${overlayMixin}
    box-sizing: border-box;
    width: 100%;
    z-index: 1;

    ${!$isLastColumn &&
    css`
      border-right: 1px solid ${borderColor};
    `}
  }
`;

export const columnTableMixin = ({
  theme: {
    column: { backgroundColor }
  }
}: MixinProps) => css<ColumnTable>`
  display: contents;

  &:before {
    ${overlayMixin}
    z-index: 0;
    width: 100%;
    background-color: ${backgroundColor};
  }

  & > div:first-child {
    scroll-snap-align: start;
    scroll-snap-stop: always;
  }
`;
